var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('router-view'),_c('v-overlay',{attrs:{"opacity":"0.55","value":_vm.overlay}},[_c('img',{attrs:{"src":require("@/assets/images/loading/loading.gif"),"alt":""}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }